import React from 'react';
import cls from 'classnames';
import Section from '../../Section';
import { publicPath } from '@/utils';
import styles from './index.module.scss';
import bgUrl from '@/static/images/business/secondary_bg.jpg';
import { useI18n } from '@/pages/business/_contexts/I18nContext';
import ArrowDownIcon from '@/static/images/business/double-arrow-down.svg';
import ScrollAnim from 'rc-scroll-anim';
const ScrollLink = ScrollAnim.Link;

const Banner = ({
  className,
  name,
  slogan,
  desc,
  img,
  showButton = false
}) => {
  const I18n = useI18n();
  return /*#__PURE__*/React.createElement(Section, {
    className: cls(styles.container, className),
    name: name,
    before: /*#__PURE__*/React.createElement("img", {
      src: bgUrl,
      className: styles.bgImg
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("h1", null, slogan), /*#__PURE__*/React.createElement("p", null, desc)), showButton && /*#__PURE__*/React.createElement(ScrollLink, {
    to: "HTJ"
  }, /*#__PURE__*/React.createElement("div", {
    className: cls('btn btn-primary', styles.joinBtn)
  }, I18n.t('TTS_Portal_Creator_ATF_CTA'), /*#__PURE__*/React.createElement(ArrowDownIcon, {
    className: styles.arrow
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.image
  }, /*#__PURE__*/React.createElement("img", {
    src: publicPath(img)
  })));
};

export default Banner;